import { VSlider } from 'vuetify/lib/components/VSlider';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rd-base-slider",class:{ 'hide-background': _vm.hideBackground, 'primary-background': !_vm.hideBackground }},[_c('div',{staticClass:"base-slider-container"},[_c(VSlider,_vm._b({style:({
				padding: _vm.incrementerPadding,
			}),attrs:{"thumb-color":"white"},on:{"change":_vm.onIncrement,"input":_vm.onInput},scopedSlots:_vm._u([{key:"append",fn:function(){return [_vm._t("between-slider-incrementer"),_c('div',{style:({ minWidth: _vm.incrementerMaxWidth ? `calc(${_vm.incrementerMaxWidth} + 42px)` : '100px', display: 'relative' })},[_c('number-with-incrementer',_vm._b({staticStyle:{"position":"absolute","top":"-5px"},style:({
							padding: _vm.incrementerPadding,
						}),attrs:{"disabled":!!_vm.$attrs.disabled,"is-currency":_vm.isCurrency,"condensed":_vm.condensedIncrementer,"value":_vm.visibleValue,"number-min-width":_vm.numberMinWidth,"max-width":_vm.incrementerMaxWidth,"round-to-nearest-step-only-on-blur":_vm.roundToNearestStepOnlyOnBlur,"editable-number-input":_vm.editableNumberInput,"selection-styles":{
							minWidth: '56px',
						}},on:{"input":_vm.onIncrement}},'number-with-incrementer',{
							...(+_vm.$attrs.step > 0 && {
								step: _vm.$attrs.step,
							}),
							...(!_vm._isNil(_vm.$attrs.min) && !_vm._isNil(_vm.$attrs.max) && {
								min: _vm.$attrs.min,
								max: _vm.$attrs.max,
							}),
						},false))],1)]},proxy:true}],null,true)},'v-slider',_vm.$attrs,false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }